import styled from "styled-components";

export const List = styled.ul`
  & li {
    margin-left: 40px;
  }
`;
